import { isNetworkAccountType, isVideoAccount } from '../../account-management';
import {
    FEATURE_FLAGS,
    useAccount,
    useConfigMatch,
} from '../../taboola-common-frontend-modules/account-configurations';
import { usePermissions } from '../../taboola-common-frontend-modules/authentication';

export const useAvailableDynamicReport = () => {
    const { type, partnerTypes } = useAccount();
    const isDynamicReportConfigEnabled = useConfigMatch({ [FEATURE_FLAGS.DYNAMIC_REPORTS_ENABLED]: 'true' });
    const isDynamicReportPermitted = usePermissions(['PERFORMANCE_DYNAMIC_REPORT_VIEW', 'DYNAMIC_REPORTS_VIEW']);
    const isNotNetworkAccount = !isNetworkAccountType(type);
    const isNotVideoAccount = !isVideoAccount(partnerTypes);

    return isDynamicReportConfigEnabled && isDynamicReportPermitted && isNotNetworkAccount && isNotVideoAccount;
};
